/**
 * 底部导航组件
 */
"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import CategoryActiveIcon from "@/assets/svg/category-active.svg";
import CategoryNormalIcon from "@/assets/svg/category-normal.svg";
import HomeActiveIcon from "@/assets/svg/home-active.svg";
// 导入SVG图标
import HomeNormalIcon from "@/assets/svg/home-normal.svg";
import MeActiveIcon from "@/assets/svg/me-active.svg";
import MeNormalIcon from "@/assets/svg/me-normal.svg";
import { isValidLocale } from "@/lib/i18n/utils";
import { cn } from "@/lib/utils";
import { useLocaleRouter } from "@/lib/utils.client";
// 导入购物车组件
import { CartButton } from "@/modules/shopping-cart/components/cart-button";
interface BottomNavigationProps {
  activeKey?: string;
  onTabChange?: (key: string) => void;
  className?: string;
}
const BottomNavigation = t0 => {
  const $ = _c(42);
  const {
    activeKey,
    onTabChange,
    className
  } = t0;
  const router = useLocaleRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== pathname) {
    t1 = () => {
      if (!pathname) {
        return "home";
      }
      const segments = pathname.split("/").filter(Boolean);
      let pathWithoutLocale = pathname;
      if (segments.length > 0 && isValidLocale(segments[0])) {
        pathWithoutLocale = `/${segments.slice(1).join("/")}`;
        if (pathWithoutLocale === "/") {} else {
          if (pathWithoutLocale === "//" || pathWithoutLocale === "") {
            pathWithoutLocale = "/";
          }
        }
      }
      const pathToKeyMap = {
        "/": "home",
        "/category": "category",
        "/account": "me",
        "/shopping-cart": "bag"
      };
      return pathToKeyMap[pathWithoutLocale] || "home";
    };
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getCurrentActiveKey = t1;
  let t2;
  if ($[2] !== activeKey || $[3] !== getCurrentActiveKey) {
    t2 = activeKey ?? getCurrentActiveKey();
    $[2] = activeKey;
    $[3] = getCurrentActiveKey;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const currentActiveKey = t2;
  const shouldShowNavigation = () => {
    if (!pathname) {
      return false;
    }
    const segments_0 = pathname.split("/").filter(Boolean);
    let pathWithoutLocale_0 = pathname;
    if (segments_0.length > 0 && isValidLocale(segments_0[0])) {
      pathWithoutLocale_0 = `/${segments_0.slice(1).join("/")}`;
      if (pathWithoutLocale_0 === "/") {} else {
        if (pathWithoutLocale_0 === "//" || pathWithoutLocale_0 === "") {
          pathWithoutLocale_0 = "/";
        }
      }
    }
    if (pathWithoutLocale_0 === "/account" && searchParams.has("tab")) {
      return false;
    }
    const allowedPaths = ["/", "/category", "/account"];
    return allowedPaths.includes(pathWithoutLocale_0);
  };
  let t3;
  if ($[5] !== t) {
    t3 = t("nav.home");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = {
      key: "home",
      title: t3,
      link: "/",
      normalIcon: HomeNormalIcon,
      activeIcon: HomeActiveIcon
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("nav.category");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      key: "category",
      title: t5,
      link: "/category",
      normalIcon: CategoryNormalIcon,
      activeIcon: CategoryActiveIcon
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("nav.bag");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = {
      key: "bag",
      title: t7,
      link: "/shopping-cart"
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("nav.me");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = {
      key: "me",
      title: t9,
      link: "/account",
      normalIcon: MeNormalIcon,
      activeIcon: MeActiveIcon
    };
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t4 || $[23] !== t6 || $[24] !== t8) {
    t11 = [t4, t6, t8, t10];
    $[21] = t10;
    $[22] = t4;
    $[23] = t6;
    $[24] = t8;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const tabs = t11;
  let t12;
  let t13;
  if ($[26] !== router || $[27] !== tabs) {
    t12 = () => {
      tabs.forEach(tab => {
        if (tab.link && !tab.link.startsWith("http") && tab.key !== "bag") {
          router.prefetch(tab.link as any);
        }
      });
    };
    t13 = [router, tabs];
    $[26] = router;
    $[27] = tabs;
    $[28] = t12;
    $[29] = t13;
  } else {
    t12 = $[28];
    t13 = $[29];
  }
  useEffect(t12, t13);
  let t14;
  if ($[30] !== onTabChange || $[31] !== router) {
    t14 = (key, link) => {
      if (key === "bag") {
        if (onTabChange) {
          onTabChange(key);
        }
        return;
      }
      if (link) {
        if (link.startsWith("http")) {
          window.open(link, "_blank");
        } else {
          router.push(link as any);
        }
      }
      if (onTabChange) {
        onTabChange(key);
      }
    };
    $[30] = onTabChange;
    $[31] = router;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const handleTabClick = t14;
  if (!shouldShowNavigation()) {
    return null;
  }
  let t15;
  if ($[33] !== className) {
    t15 = cn("relative z-50", "h-[3.5rem] bg-white", "px-0 py-2", "flex items-center justify-center", className);
    $[33] = className;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== currentActiveKey || $[36] !== handleTabClick || $[37] !== tabs) {
    t16 = <div className="flex w-full max-w-md items-center justify-between">{tabs.map(tab_0 => {
        const isActive = currentActiveKey === tab_0.key;
        if (tab_0.key === "bag") {
          return <div key={tab_0.key} onClick={() => handleTabClick(tab_0.key)} className={cn("flex flex-col items-center justify-center", "h-full flex-1", "transition-colors duration-200", "cursor-pointer")}><div className={cn("mb-px h-6 w-6", "flex items-center justify-center")}><CartButton variant="bottom-nav" isActive={isActive} /></div><span className={cn("text-xs leading-none", isActive ? "font-['DINPro-Medium'] text-black" : "font-['DINPro-Regular'] text-[#666666]")}>{tab_0.title}</span></div>;
        }
        const IconComponent = isActive ? tab_0.activeIcon : tab_0.normalIcon;
        return <button type="button" key={tab_0.key} onClick={() => handleTabClick(tab_0.key, tab_0.link)} className={cn("flex flex-col items-center justify-center", "h-full flex-1", "transition-colors duration-200")}><div className={cn("mb-px", "flex items-center justify-center")}><IconComponent className="h-6 w-6" /></div><span className={cn("text-xs leading-none", isActive ? "font-['DINPro-Medium'] text-black" : "font-['DINPro-Regular'] text-[#666666]")}>{tab_0.title}</span></button>;
      })}</div>;
    $[35] = currentActiveKey;
    $[36] = handleTabClick;
    $[37] = tabs;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t15 || $[40] !== t16) {
    t17 = <div className="sticky right-0 bottom-[-1px] left-0 z-102 md:hidden"><div className={t15}>{t16}</div></div>;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
};
export default BottomNavigation;